import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

import test from '../../../../assets/images/profile/list.png';
import closeIcon from '../../../../assets/images/profile/close-icon-small.png';
import rightArrow from '../../../../assets/images/settings/right-arrow.png';
import Api from '../../../../__helpers/api';

function Exam(props) {

    const [exam, setExam] = useState({
        popup: false,
        overlay: false,
    });

    const [exams, setExams] = useState({
        data: [],
        loading: true
    });

    useEffect(() => {

        Api.get('student/exams')
            .then(res => {
                setExams(prev => ({ ...prev, data: res.data, loading: false }));
            }).catch(err => {
                setExams(prev => ({ ...prev, data: [], loading: false }));
            })

        let hide = window.localStorage.getItem('hide-exam-popup');

        if (!hide) {
            handleShow();
        }

    }, []);

    const handleClose = () => {
        setExam(exam => {
            return {
                ...exam,
                popup: false,
            }
        })
        setTimeout(() => {
            setExam(exam => {
                return {
                    ...exam,
                    overlay: false
                }
            })
        }, 100);

        window.localStorage.setItem('hide-exam-popup', 1);

    }

    const handleShow = () => {
        setExam(exam => {
            return {
                ...exam,
                overlay: true,
            }
        })
        setTimeout(() => {
            setExam(exam => {
                return {
                    ...exam,
                    popup: true
                }
            })
        }, 100);
    }

    const handleExam = () => {
        window.localStorage.setItem('hide-exam-popup', 1);
    }

    return (
        !exams.loading
            ?
            <div className="exam">
                <div id="overlay" className={exam.overlay ? 'visible' : ''}>
                    <div className={[exam.popup ? 'show' : '', 'ready-for-exam'].join(' ')}>
                        <img src={closeIcon} alt="close" onClick={handleClose} />
                        <div className="left">
                            <h2>
                                Изпит идентичен с официалния
                            </h2>
                            <p>
                                Продължи обучението си по теория като решаваш идентичен изпит с официалния.
                                Той съдържа 45 въпроса с време за решаване 40 мин. За оценка ДА е необходимо да решиш изпита
                                с поне 87 от общо 97 точки. Всички резултати са достъпни за твоя преподавател по теория.
                            </p>
                            <p>
                                До момента са решени {props.quantity}% от всички изпитни въпроси.
                                <br />
                                Продължи обучение с Решаване на изпит.
                            </p>
                            <h3>
                                {props.quantity}% РЕШЕНИ ВЪПРОСИ
                            </h3>
                            <div className="buttons">
                                <Button className="later" onClick={handleClose}>
                                    Реши по-късно
                                </Button>
                                <Button onClick={handleExam}>
                                    <Link to="/test?exam=1">
                                        Решаване на изпит
                                    <img src={rightArrow} alt="go" />
                                    </Link>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="left">
                    <h2>
                        Решаване на изпит
                    </h2>
                    <p>
                        Продължи обучението си по теория като решаваш идентичен изпит с официалния. Той съдържа 45 въпроса с
                        време за решаване 40 мин. За оценка ДА е необходимо да решиш изпита с поне 87 от общо 97 точки.
                        Всички резултати са достъпни за твоя преподавател по теория.
                    </p>

                    <div className="bottom-part">
                        <div className="total-questions">
                            <p>
                                {props.quantity}%
                            <img src={test} alt="test" />
                            </p>

                            <div className="indicator">
                                <div className="slider" style={{ width: props.quantity + '%' }}>

                                </div>
                            </div>

                            <span>
                                Решени въпроси
                            </span>
                        </div>
                        <div className="results">
                            <ul>
                                {exams.data.map(e =>
                                    <li className={e.pass ? 'yes' : 'no'} style={window.innerWidth <= 1024 ? { width: ((e.points / e.max_points) * 100) + '%' } : { height: ((e.points / e.max_points) * 100) + '%' }}>
                                        <h5>
                                            {e.pass ? 'ДА' : 'НЕ'}
                                        </h5>
                                        <h4>
                                            {e.points}
                                            <span>
                                             точки
                                            </span>
                                        </h4>
                                        <h3>
                                            № {e.number}
                                        </h3>
                                    </li>
                                )}

                                <li className="button-li">
                                    <Button onClick={handleExam}>
                                        <Link to="/test?exam=1">
                                            Решаване на изпит
                                        <img src={rightArrow} alt="go" />
                                        </Link>
                                    </Button>
                                </li>
                            </ul>
                            <span>
                                Последно решени изпитни тестове
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            :
            ''

    )
}

export default Exam;